module.exports = __webpack_public_path__ + "16e1d930cf13fb7a956372044b6d02d0.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto-v15-latin-regular.woff
// module id = 1088
// module chunks = 0